var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-trigger icon-cart",on:{"click":function($event){return _vm.openCart()}}},[_c('client-only',[(_vm.cartQty > 0)?_c('span',{staticClass:"cart-count"},[_vm._v(_vm._s(_vm.cartQty))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }